/*
Author: Jeewantha Karunarathna
Date: 10/12/2024
Copyright © 2024 Infix!. All rights reserved.
*/

import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'

export interface ICommonState {
    userType: string | null
}

const initialState: ICommonState = {
    userType: null,
}

const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        setUserType: (
            state,
            action: PayloadAction<{
                value: string | null
            }>
        ) => {
            const { value } = action.payload
            state.userType = value
        },
    },
})

export const { setUserType } = commonSlice.actions

export const useSetUserType = () => {
    const dispatch = useDispatch()

    const updateCommonData = (value: string | null) => {
        dispatch(setUserType({ value: value }))
    }

    return updateCommonData
}

export default commonSlice.reducer
